import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './ui/Countdown';
export function UrgencyBlock() {
  return <section className="py-10 md:py-14 bg-clinical-deep text-white" data-id="element-434">
      <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-435">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-accent mb-4" data-id="element-436">
          Oferta de lanzamiento
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl md:text-4xl font-black mb-6 md:mb-7 text-white leading-tight uppercase" data-id="element-437">
          El precio{' '}
          <span className="accent-italic-gold normal-case" data-id="element-438">cierra en</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="flex justify-center mb-6 md:mb-7" data-id="element-439">
          <Countdown data-id="element-440" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-sm sm:text-base md:text-lg text-white/80 font-medium mb-6 md:mb-7" data-id="element-441">
          Después sube <span className="font-bold text-white" data-id="element-442">$15.000 ARS</span>
          . <span className="accent-italic-gold" data-id="element-443">No vuelve.</span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="max-w-md mx-auto bg-white/5 p-4 md:p-5 rounded-2xl border border-white/10" data-id="element-444">
          <div className="flex justify-between text-xs sm:text-sm font-medium mb-2.5" data-id="element-445">
            <span className="text-white/80" data-id="element-446">
              Cupos al precio de lanzamiento
            </span>
            <span className="text-clinical-accent font-semibold" data-id="element-447">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-white/10 rounded-full h-2 mb-3 overflow-hidden" data-id="element-448">
            <div className="bg-clinical-accent h-2 rounded-full" style={{
            width: '68%'
          }} data-id="element-449"></div>
          </div>

          <p className="text-[11px] sm:text-xs text-white/60" data-id="element-450">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </motion.div>
      </div>
    </section>;
}